import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import { PontoIntegrationInterface } from "../../Entity/Entities/PontoIntegration/PontoIntegrationInterface";

class PontoIntegrationUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const payload: PontoIntegrationInterface = props?.res;
    if (!payload) return;

    this.props.dispatch({ type: Constants.PONTO_AUTHORIZATION_UPDATE, payload });
  }
}

export { PontoIntegrationUpdate };
